// select下拉常量
import dic from '@/common/dic';
// 配置文件
import config from '@/config';
// 表单验证扩展
import validate from '@/common/validate';

// 工具化函数
import utils from '@/common/utils';

const common = {
  dic,
  validate,
  config,
  utils,
};
export {
  dic,
  validate,
  config,
  utils,
};
export default common;
